<template>
  <div>
    <a-button type="primary" icon="plus-circle" @click="handleAddLink">添加链接</a-button>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :loading="loading" :data-source="data" :columns="columns" :pagination="false" style="margin-top: 20px" @change="handleTableChange">
      <template slot="org" slot-scope="text">
        <a-tag color="blue">{{ text }}</a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
        <a-button size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
      </template>
    </a-table>

    <!-- 添加链接 -->
    <a-modal width="40%" v-model="visible" :title="title" :afterClose="handleCancel">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{span: 5}" :wrapper-col="{span: 19}">
        <a-form-model-item label="选择业务线" prop="line_id">
          <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请输入">
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="文章分类" prop="typeids">
          <a-select v-model="form.typeids" mode="multiple" allowClear show-search option-filter-prop="children" placeholder="请选择">
            <a-select-option v-for="item in classifyList" :key="item.id" :value="item.id">
              <a-tooltip placement="topLeft" :title="item.path_name" arrow-point-at-center>
                {{ item.path_name }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="PC文章详情地址" prop="pc_detail_url">
          <a-input v-model="form.pc_detail_url" placeholder="请输入" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="APP文章详情地址" prop="app_detail_url">
          <a-input v-model="form.app_detail_url" placeholder="请输入" style="width: 100%" />
        </a-form-model-item>
        <div>Tips：文章id请用 %id% 代替</div>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取 消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
          提 交
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { strategyCommand, title } from './business/tableLogic'
import { columns, form, rules } from './business/classifyList'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
import api from '@/api/'

export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()
    // 分页信息
    const pagData = pagination()
    const { handleTableChange } = pagData

    const state = reactive({
      ...pagData, // 全局分页信息
      form,
      rules,
      columns,
      platformList: [],
      title: title.Add,
      classifyList: []
    })

    onMounted(async () => {
      await Promise.all([methods.getArticleClassify(), methods.getPlatform()])
      methods.getList()
    })

    const methods = {
      // 获取列表
      async getList() {
        state.loading = true
        const res = await api.listPreview()
        const { articlePreview, pagination } = res.data
        state.data = articlePreview
        state.loading = false
      },

      getPlatform: async function() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      // 提交编辑
      handleSubmit() {
        _this.$refs.formDom.validate(async valid => {
          if (valid) {
            const data = JSON.parse(JSON.stringify({ ...state.form, typeids: state.form.typeids.join(',') }))
            let res = null
            if (state.isEdit) {
              res = await api.updatePreview(data)
            } else {
              res = await api.createPreview(data)
            }
            if (_this.$validate(res)) {
              _this.$message.success(state.isEdit ? '编辑成功~' : '新增成功~')
              _this.visible = false
              methods.getList()
            }
          }
        })
      },

      // 新增标签
      handleAddLink() {
        state.visible = true
        state.isEdit = false
        state.title = title.Add
      },

      // 关闭弹窗
      handleCancel() {
        _this.$nextTick(() => _this.$refs.formDom.resetFields())
        state.visible = false
      },

      // 表格操作
      handleTableCommand(type, data) {
        strategyCommand[type].call(_this, {
          ...data,
          line_id: Number(data.line_id),
          typeids: data.typeids ? data.typeids : []
        })
      },

      // 获取文章分类
      async getArticleClassify() {
        const res = await api.listClassify()
          state.classifyList = res?.data?.articleType
      }
    }

    return {
      ...toRefs(state),

      ...compuedFun(),
      ...methods
    }
  }
}
</script>
<style lang='less'>
</style>
